import { formatDate } from "../../utils";
const FormatDateTime = (props) => {
    return (
      <div>
        {formatDate(props.value,'mm/dd/yyyy h:m:s')}
      </div>
    );
}

export default FormatDateTime;